module.exports = __webpack_public_path__ + "img/PhoneTag_DG.df808e21.png";